import type { ResourcesConfig } from 'aws-amplify';
import { environment } from '../../../environments/environment';

/**
 * Builds the AWS Amplify configuration object from environment.cognito.
 * Mirrors the pattern used in jira-reports-webui's src/aws-config.ts.
 */
export function getAwsConfig(): ResourcesConfig {
  const { cognito } = environment;
  const redirectUrl = `${window.location.origin}/auth/callback`;

  return {
    Auth: {
      Cognito: {
        userPoolId: cognito.userPoolId,
        userPoolClientId: cognito.userPoolClientId,
        region: cognito.region,
        loginWith: {
          oauth: {
            domain: cognito.cognitoDomain,
            scopes: cognito.scopes,
            redirectSignIn: [redirectUrl],
            redirectSignOut: [redirectUrl],
            responseType: 'code' as const
          }
        }
      }
    }
  } as ResourcesConfig;
}
